export default {
	compteCree: 'Votre compte est créé, vous allez recevoir un email afin de l\'activer',
	errorCgu: 'Merci d\'accepter les CGU avant de vous inscrire',
	forgottenPassword: 'Si l\'adresse indiquée est associée à un compte, un nouveau lien de réinitialisation vous a été envoyé par email',
	caseErrorCgu: 'Vous devez accepter les Conditions Générales d\'Utilisation afin de poursuivre votre inscription'
};
